import './styles/TransferTermsConditions_W.scss';

import { useMemo } from 'react';

import { Stack } from '../../../../components/Stack';
import { useClassHelper } from '../../../../hooks';
// Local Helper
import { WebsheetTemplateProps } from '../../../../types';
import { TermsAndConditionsBase } from '../../components/TermsAndConditionsBase';
import { useGetStyles } from '../../hooks/useGetStyles';
import { useLocalisation } from '../../hooks/useLocalisation';
import { resolveTransferTermsText } from './helpers';

const componentName = 'c-TransferTermsConditionsW';

interface Props extends WebsheetTemplateProps {
  onClose?: () => void;
  // 'linked' (sa-watch / standalone) renders the standalone T&C copy variant;
  // defaults to the paired (Multi-SIM) copy when false/omitted.
  isLinked?: boolean;
  'data-dd-action-name'?: string;
}

const defaultValues = {
  title: 'Terms & Conditions',
  content: [],
  watch_transfer_watch_button: 'Back',
};

export const TransferTermsConditionsW = (props: Props) => {
  const getStyles = useGetStyles({ values: props.values });
  const {
    values,
    currentLocale,
    onClose,
    isPortalPreview,
    isLinked,
    'data-dd-action-name': dataDdActionName,
  } = props;
  const { localisations } = values;
  const c = useClassHelper(componentName);

  const localisation = useLocalisation(localisations, currentLocale);

  const handleClose = () => {
    onClose?.();
  };

  const getTermsAndConditions = () => {
    if (localisation?.['transfer_t&c']) {
      const resolved = resolveTransferTermsText(
        Boolean(isLinked),
        localisation['transfer_t&c'],
      );
      return {
        title: resolved.title || defaultValues.title,
        content: resolved.content || defaultValues.content,
        watch_transfer_watch_button:
          resolved.watch_transfer_watch_button ||
          defaultValues.watch_transfer_watch_button,
      };
    }

    if (props?.text) {
      const resolved = resolveTransferTermsText(Boolean(isLinked), props.text);
      return {
        title: resolved.title || defaultValues.title,
        content: resolved.content || defaultValues.content,
        watch_transfer_watch_button:
          resolved.watch_transfer_watch_button ||
          defaultValues.watch_transfer_watch_button,
      };
    }

    return defaultValues;
  };

  const { title, content, watch_transfer_watch_button } = useMemo(() => {
    return getTermsAndConditions();
  }, [localisation, props]);

  return (
    <TermsAndConditionsBase
      getStyles={getStyles}
      isPortalPreview={isPortalPreview}
      styling={{
        logoUrl: values?.logoUrl,
        title: {
          text: title || 'Terms & Conditions',
          fontFamily: values?.fontTitle,
        },
        content: {
          text: content,
          valueFontParagraph: values?.fontParagraph,
        },
      }}
      footer={
        <Stack direction="row" justify="between">
          <button
            type="button"
            className={c('__highlight')}
            onClick={handleClose}
            style={{
              color: values?.colorLink,
            }}
            data-dd-action-name={dataDdActionName}
          >
            {watch_transfer_watch_button}
          </button>
        </Stack>
      }
    />
  );
};
